import Stack from '@mui/material/Stack';
import { JuicyTypography } from '../../components/index.ts';
import { CountdownTile, RippleWaves } from '../../features/index.ts';
import { useNavigate } from 'react-router';
import { useCallback, useMemo, useState } from 'react';
import { Typography, useTheme } from '@mui/material';
import { NFCPaymentMethodIcon } from '../../assets/icons/nfc-payment-method.tsx';
import { MoneyballPaymentMethodIcon } from '../../assets/icons/moneyball-payment-method.tsx';
import { NFCIcon } from '../../assets/icons/nfc.tsx';
import Box from '@mui/material/Box';
import { ArrowIcon } from '../../assets/icons/arrow.tsx';
import { Path } from '../../assets/enums/index.ts';
import { PlusIcon } from '../../assets/icons/plus.tsx';
import { Button } from '../../components/button/index.ts';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { backButtonSx, getButtonSx, getLineSx, getPromoAppliedFieldSx, getWrapperSx, promoButtonSx } from './styles.ts';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import { PromoDrawer } from '../../features/promo-drawer/index.ts';
import { CheckIcon } from '../../assets/icons/check.tsx';

export const PaymentMethodPage = () => {
  const theme = useTheme();
  const { palette } = theme;
  const { gameSessionParams, clearGameSessionContext, setParams } = useGameSessionContext();
  const nav = useNavigate();
  const [selectedMethodId, setSelectedMethodId] = useState(1);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isPromoApplied, setIsPromoApplied] = useState(Boolean(gameSessionParams?.amountWithDiscount));
  const isCardPaymentMethodActive = useMemo(() => selectedMethodId === 1, [selectedMethodId]);
  const closeDrawer = () => setIsDrawerOpen(false);

  const onTimerRunsOut = useCallback(() => {
    clearGameSessionContext();
    nav(Path.Home);
  }, [nav, clearGameSessionContext]);

  const paymentMethods = useMemo(() => {
      return [
        {
          id: 1,
          title: 'Tap to Play',
          subtitle: 'Card ・Apple Pay・Google Pay ',
          Icon: <NFCPaymentMethodIcon
            color={theme.palette.dark}
          />,
        },
        {
          id: 2,
          title: 'Use Moneyball Balance ',
          subtitle: '$240 available on this account',
          Icon: <MoneyballPaymentMethodIcon color={theme.palette.dark} />,
        },
      ];
    }, [theme],
  );

  const onPromoApplied = useCallback(() => {
    setIsPromoApplied(true);
    if (gameSessionParams?.amount) {
      setParams({ amountWithDiscount: Number(gameSessionParams.amount) - 5 });
    }
  }, [gameSessionParams, setParams]);

  const GameCostNode = useMemo(() => {
    const isDiscountApplied = Boolean(isPromoApplied);
    const gameCostWithDiscount = gameSessionParams.amount;
    return (
      <Stack direction="row" gap={10} mb={12}>
        {isDiscountApplied &&
          <JuicyTypography variantStyle={'orange'} typography={'giant'}
          >${gameCostWithDiscount}</JuicyTypography>
        }
        <Box position={'relative'}>
          <JuicyTypography sx={{ opacity: isDiscountApplied ? 0.5 : 1 }} variantStyle={'orange'}
                           typography={'giant'}>${gameSessionParams.amountWithDiscountOrAmount}</JuicyTypography>
          {isDiscountApplied && <Box sx={getLineSx} />}
        </Box>

      </Stack>
    );
  }, [gameSessionParams, isPromoApplied]);

  return (
    <Stack sx={getWrapperSx(theme)}>
      <Box position={'relative'} mb={44}>
        <JuicyTypography>Choose your payment method</JuicyTypography>
        <Box right={7} bottom={20} position={'absolute'}>
          <CountdownTile totalSeconds={60} variant={'circle'}
                         onComplete={onTimerRunsOut}
          />
        </Box>
      </Box>

      <JuicyTypography variantStyle={'orange'} typography={'title'}>Amount</JuicyTypography>

      {GameCostNode}




      <Stack gap={10}>
        {paymentMethods.map((el) => {
          const isActive = selectedMethodId === el.id;
          return (
            <Button
              component={'div'}
              variantStyle={'secondary'}
              active={isActive}
              onClick={() => setSelectedMethodId(el.id)}
              key={el.id}

            >
              <Stack direction={'row'} width={'100%'} gap={6}>
                {el.Icon}
                <Stack gap={4}
                       alignItems={'baseline'}>
                  <Typography variant={'button_alt'}>{el.title}</Typography>
                  <Typography variant={'description'}>{el.subtitle}</Typography>
                </Stack>
              </Stack>


              {!isCardPaymentMethodActive && isActive && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    nav(Path.PaymentSuccess);
                  }}
                  sx={getButtonSx(theme)}>
                  <Typography variant={'button_alt'}>
                    pay
                  </Typography>
                  <ArrowIcon />
                </Button>
              )}

            </Button>
          );
        })
        }

        {isPromoApplied ? (
          <Stack
            direction={'row'}
            gap={6}
            sx={getPromoAppliedFieldSx(theme)}>
            <CheckIcon />
            <Typography variant={'button_alt'}>Promo Code Applied!</Typography>
          </Stack>
        ) : (
          <Button variantStyle={'secondary'} sx={promoButtonSx} onClick={() => setIsDrawerOpen(true)}>
            <Stack direction={'row'} gap={6} alignItems={'center'} justifyContent={'start'}>
              <PlusIcon />
              <Typography variant={'button_alt'}>
                Enter Promo Code
              </Typography>
            </Stack>
          </Button>
        )}

      </Stack>

      <Stack alignItems={'center'} justifyContent={'end'} height={'100%'} width={'230%'} alignSelf={'center'}>
        <Box position={'relative'} height={136}>
          <NFCIcon color={palette.accent} style={{ opacity: isCardPaymentMethodActive ? 1 : 0.7 }} />
          {isCardPaymentMethodActive && <RippleWaves width={175} height={136} />}
        </Box>
      </Stack>
      <PageBackButton sx={backButtonSx} onClick={() => nav(Path.GameSettings)} />
      <PromoDrawer open={isDrawerOpen} handleClose={closeDrawer} onPromoApplied={onPromoApplied} />

    </Stack>
  );
};